import type { LegalCopy } from '../types'

export const asm: LegalCopy = {
  title: 'আইনী সহায়',
  subtitle: 'সাধাৰণ আইনী সমস্যা, সহজ কথাত বুজোৱা হৈছে। নিজৰ ভাষাত শুনক, আৰু প্ৰতিটো উত্তৰৰ চৰকাৰী উৎস চাওক।',
  helplinesTitle: 'হেল্পলাইন (বিনামূলীয়া কল)',
  helplines: {
    emergency: 'জৰুৰীকালীন: পুলিচ, অগ্নিনিৰ্বাপক, এম্বুলেন্স',
    legal_aid: 'বিনামূলীয়া আইনী সহায় (NALSA)',
    cyber: 'অনলাইন / UPI প্ৰতাৰণা',
    women: 'মহিলা হেল্পলাইন',
    consumer: 'উপভোক্তা হেল্পলাইন'
  },
  faqTitle: 'সাধাৰণ প্ৰশ্ন',
  searchPlaceholder: 'বিচাৰক: FIR, প্ৰতাৰণা, RTI, উকীল…',
  noMatch: 'কোনো প্ৰশ্ন মিল নাখালে। তলত নিজৰ প্ৰশ্ন সোধক।',
  sources: 'চৰকাৰী উৎস',
  listen: 'শুনক',
  askTitle: 'নিজৰ আইনী প্ৰশ্ন সোধক',
  askHint: 'সমঝোৱে কেৱল চৰকাৰী ৱেবছাইটৰ পৰা উত্তৰ দিয়ে, উৎসৰ লিংকৰ সৈতে।',
  starters: ['মই বিনামূলীয়া উকীল পাব পাৰোঁনে?', 'কোনোবাই মোক অনলাইনত ঠগিলে। মই কি কৰিম?', 'পুলিচে মোৰ অভিযোগ লিখা নাই। মই কি কৰিব পাৰোঁ?'],
  disclaimer:
    'এইটো চৰকাৰী উৎসৰ পৰা লোৱা সাধাৰণ তথ্য, আপোনাৰ গোচৰৰ বাবে আইনী পৰামৰ্শ নহয়। নিজৰ গোচৰৰ বাবে উকীলৰ সৈতে কথা পাতক — আইনী সেৱা কৰ্তৃপক্ষৰ (15100) পৰা বিনামূলীয়াকৈ উকীল পাব পাৰে।',
  topics: {
    get_free_aid: {
      q: 'বিনামূলীয়া আইনী সহায় কেনেকৈ পাম?',
      a: 'NALSA-ৰ বিনামূলীয়া হেল্পলাইন 15100 নম্বৰত কল কৰক। নহলে আপোনাৰ জিলা আদালতত থকা আইনী সেৱা কৰ্তৃপক্ষৰ কাৰ্যালয়লৈ, বা তালুকা আদালতত থকা আইনী সেৱা সমিতিলৈ যাওক। আপুনি অনলাইনত, ডাকযোগে বা ই-মেইলেৰেও আবেদন কৰিব পাৰে। ফৰ্মখন বিনামূলীয়া, আৰু উকীলৰ ফী আৰু আদালতৰ খৰচ আপোনাৰ হৈ দিয়া হয়।'
    },
    who_free_aid: {
      q: 'কোনে বিনামূলীয়া উকীল পাব পাৰে?',
      a: 'আইনে (আইনী সেৱা কৰ্তৃপক্ষ আইনৰ ধাৰা 12) এওঁলোকক বিনামূলীয়া আইনী সহায় দিয়ে: মহিলা আৰু শিশু, SC/ST সম্প্ৰদায়ৰ লোক, দিব্যাংগ ব্যক্তি, উদ্যোগৰ শ্ৰমিক, মানৱ চোৰাং ব্যৱসায় বা বলপূৰ্বক শ্ৰমৰ (বেগাৰ) বলি হোৱা লোক, দুৰ্যোগ, জাতিভেদৰ অত্যাচাৰ বা জনগোষ্ঠীগত হিংসাৰ বলি হোৱা লোক, হেফাজতত থকা লোক, আৰু যিসকলৰ বছৰেকীয়া আয় তেওঁলোকৰ ৰাজ্যই ঠিক কৰা সীমাতকৈ কম। আয়ৰ সীমা প্ৰতিখন ৰাজ্যত বেলেগ।'
    },
    fir: {
      q: 'পুলিচে মোৰ FIR লোৱা নাই। মই কি কৰিম?',
      a: 'গুৰুতৰ (আমলযোগ্য) অপৰাধৰ বিষয়ে আপুনি যিকোনো থানাত জনাব পাৰে, অপৰাধটো আন ঠাইত ঘটিলেও — ইয়াক জিৰো FIR বোলে। পুলিচে আপোনাক FIR-ৰ এটা কপি বিনামূলীয়াকৈ দিবই লাগিব। পুলিচে মান্তি নহ’লে, আপোনাৰ অভিযোগ লিখি ডাকযোগে আৰক্ষী অধীক্ষক (SP)লৈ পঠিয়াওক। SP-য়েও একো নকৰিলে, আপুনি শপতনামাৰ সৈতে মেজিষ্ট্ৰেটৰ ওচৰত আবেদন কৰিব পাৰে।'
    },
    cyber_fraud: {
      q: 'অনলাইন বা UPI প্ৰতাৰণাত মোৰ টকা গ’ল। কি কৰিম?',
      a: 'লগে লগে 1930 নম্বৰত কল কৰক — এইটো ৰাষ্ট্ৰীয় চাইবাৰ অপৰাধ হেল্পলাইন, বিনামূলীয়া, দিনে-ৰাতিয়ে খোলা থাকে। সোনকালে জনালে টকাখিনি আন ঠাইলৈ সৰাই নিয়াটো ৰখাত সহায় হয়। লগতে cybercrime.gov.in ৱেবছাইটত “Financial Fraud” অংশত অভিযোগ দিয়ক।'
    },
    women: {
      q: 'কোনো মহিলাই হিংসা বা হাৰাশাস্তিৰ সন্মুখীন হৈছে। তেওঁ ক’ত সহায় পাব?',
      a: 'জৰুৰীকালীন অৱস্থাত পুলিচ, অগ্নিনিৰ্বাপক বা এম্বুলেন্সৰ বাবে 112 নম্বৰত ফোন কৰক। বিনামূলীয়া মহিলা হেল্পলাইন 181 নম্বৰত দিনে-ৰাতিয়ে যিকোনো সময়তে কল কৰক। আপুনি নিজৰ নাম গোপনে ৰাখিব পাৰে, আৰু ই আপোনাক পুলিচ, ৱান ষ্টপ চেণ্টাৰ, চিকিৎসালয় বা আইনী সহায়ৰ সৈতে সংযোগ কৰি দিয়ে। ৰাষ্ট্ৰীয় মহিলা আয়োগৰো এটা হেল্পলাইন আছে, 14490, আৰু তেওঁলোকে অনলাইনত অভিযোগো লয়।'
    },
    consumer: {
      q: 'কোনো দোকান বা কোম্পানীয়ে মোক ঠগিলে। ক’ত অভিযোগ কৰিম?',
      a: 'ৰাষ্ট্ৰীয় উপভোক্তা হেল্পলাইন 1915 নম্বৰত কল কৰক (বিনামূলীয়া, পুৱা 8 বজাৰ পৰা ৰাতি 8 বজালৈ), 8800001915 নম্বৰলৈ WhatsApp বাৰ্তা পঠিয়াওক, বা consumerhelpline.gov.in ৱেবছাইটত অভিযোগ কৰক। উপভোক্তা আয়োগত গোচৰ তৰিব লাগিলে, e-Daakhil-ত অনলাইনত কৰিব পাৰে।'
    },
    summons: {
      q: 'মই আদালতৰ চমন পাইছোঁ। কি কৰিম?',
      a: 'চমনত লিখা থাকে কোন তাৰিখে আপুনি আদালতলৈ আহিব লাগিব। আপুনি যোগ্য হ’লে, গোচৰৰ যিকোনো পৰ্যায়ত বিনামূলীয়া উকীল পাব পাৰে: 15100 নম্বৰত কল কৰক বা আপোনাৰ জিলা আদালতত থকা আইনী সেৱাৰ কাৰ্যালয়লৈ যাওক। আপোনাৰ গোচৰ আৰু ইয়াৰ পিছৰ তাৰিখ eCourts ৱেবছাইট বা এপত চাব পাৰে।'
    },
    case_status: {
      q: 'মোৰ আদালতৰ গোচৰৰ স্থিতি (ষ্টেটাছ) কেনেকৈ চাম?',
      a: 'services.ecourts.gov.in ৱেবছাইটলৈ যাওক, বা eCourts ছাৰ্ভিচেছ এপ ব্যৱহাৰ কৰক, আৰু আপোনাৰ 16 অংকৰ CNR নম্বৰ বা গোচৰৰ আন তথ্যৰে বিচাৰক। এছএমএছো পঠিয়াব পাৰে: ECOURTS, তাৰ পিছত এটা স্পেচ, তাৰ পিছত আপোনাৰ CNR নম্বৰ লিখি 9766899899 নম্বৰলৈ পঠিয়াওক।'
    },
    lok_adalat: {
      q: 'লোক আদালত কি?',
      a: 'লোক আদালতে দুয়োপক্ষৰ সন্মতিৰে গোচৰ নিষ্পত্তি কৰে। ইয়াত কোনো কোৰ্ট ফী নালাগে, আৰু আদালতত আগৰে পৰা চলি থকা গোচৰ ইয়াত মীমাংসা হ’লে, আপুনি দিয়া কোৰ্ট ফী ঘূৰাই দিয়া হয়। ইয়াৰ সিদ্ধান্ত আদালতৰ ডিক্ৰীৰ দৰেই চূড়ান্ত, আৰু সেয়া মানিবই লাগিব। ইয়াৰ বিৰুদ্ধে কোনো আপীল কৰিব নোৱাৰি।'
    },
    rti: {
      q: 'RTI কেনেকৈ দাখিল কৰিম?',
      a: 'কেন্দ্ৰীয় চৰকাৰৰ কাৰ্যালয়ৰ বাবে rtionline.gov.in ৱেবছাইটত অনলাইনত আবেদন কৰক। ফী ₹10; আপুনি দৰিদ্ৰসীমাৰ তলত থাকিলে কোনো ফী নালাগে (আপোনাৰ BPL প্ৰমাণপত্ৰ লগত দিয়ক)। বিষয়াজনে 30 দিনৰ ভিতৰত উত্তৰ দিব লাগিব, আৰু কাৰোবাৰ জীৱন বা স্বাধীনতাৰ কথা হ’লে 48 ঘণ্টাৰ ভিতৰত। 30 দিনত উত্তৰ নাপালে, পিছৰ 30 দিনৰ ভিতৰত বিনামূলীয়াকৈ প্ৰথম আপীল কৰিব পাৰে।'
    },
    grievance: {
      q: 'চৰকাৰী কাৰ্যালয়ে মোৰ কাম কৰা নাই। ক’ত অভিযোগ কৰিম?',
      a: 'pgportal.gov.in ৱেবছাইটত CPGRAMS-ত অভিযোগ দাখিল কৰক — এইটো দিনে-ৰাতিয়ে খোলা থাকে (ইয়াৰ এপত আৰু UMANG-তো কৰিব পাৰি)। 21 দিনৰ ভিতৰত সমাধান কৰাৰ লক্ষ্য ৰখা হৈছে। ইয়াত RTI-ৰ বিষয়, আদালতৰ গোচৰ, ধৰ্মীয় বিষয় বা চৰকাৰী কৰ্মচাৰীৰ চাকৰি সম্পৰ্কীয় বিষয় লোৱা নহয়।'
    }
  }
}
